function changeAriaLabel() {
    const carousel = document.querySelector('[data-js-module="logo-slider"]');

    if(carousel) {
        const buttonPrev = carousel.querySelector('.slick-prev'),
            buttonNext = carousel.querySelector('.slick-next');

        if(buttonPrev) {
            buttonPrev.setAttribute('aria-label', 'Poprzedni');
        };

        if(buttonNext) {
            buttonNext.setAttribute('aria-label', 'Następny');
        };
    }
}

export default changeAriaLabel;